import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function PaymentHoldsPanel({
  holds,
}: {
  holds: Array<{ _id: string; reason: string; note?: string; placedBy: string; placedAt: number; releasedAt?: number }>;
}) {
  const active = holds.filter((hold) => !hold.releasedAt);
  return (
    <Card>
      <CardHeader className="p-3">
        <CardTitle className="flex items-center justify-between gap-3 text-sm">
          Payment Holds
          <Badge variant={active.length > 0 ? "bad" : "good"}>{active.length > 0 ? "held" : "clear"}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 p-3 text-sm">
        {active.length === 0 ? (
          <div className="text-muted-foreground">No active carrier payment holds.</div>
        ) : (
          active.map((hold) => (
            <div key={hold._id} className="rounded-md border border-border p-2">
              <div className="font-medium">{hold.reason.replaceAll("_", " ")}</div>
              <div className="text-muted-foreground">{hold.note ?? "No note"}</div>
              <div className="mt-1 text-xs text-muted-foreground">
                Placed by {hold.placedBy} at {new Date(hold.placedAt).toLocaleString()}
              </div>
            </div>
          ))
        )}
      </CardContent>
    </Card>
  );
}
